import { apiCall } from '../../../_services/apiCall';
import config from '../../../config/config.json';

const BASE_URL = `${config.POSTLOGIN_API_URL_COMPANY}doc-sense`;

// ---- Documents ----
export const listDocuments = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.financialYear) query.append('financialYear', params.financialYear);
  if (params.locationId) query.append('locationId', params.locationId);
  if (params.subLocationId) query.append('subLocationId', params.subLocationId);
  if (params.status) query.append('status', params.status);
  const qs = query.toString();
  const response = await apiCall(
    `${BASE_URL}/documents${qs ? `?${qs}` : ''}`,
    {}, {}, 'GET'
  );
  return response?.data || [];
};

export const uploadDocument = async (file, financialYearId, locationId, subLocationId) => {
  const formData = new FormData();
  formData.append('file', file);
  if (financialYearId) formData.append('financialYearId', financialYearId);
  if (locationId) formData.append('sourceId', locationId);
  if (subLocationId) formData.append('subLocationId', subLocationId);
  const response = await apiCall(`${BASE_URL}/documents`, {}, formData, 'POST');
  return response?.data;
};

export const getDocumentById = async (id) => {
  const response = await apiCall(`${BASE_URL}/documents/${id}`, {}, {}, 'GET');
  return response?.data;
};

export const getDocumentStatus = async (id) => {
  const response = await apiCall(
    `${BASE_URL}/documents/${id}/status`,
    {}, {}, 'GET', true, false
  );
  return response?.data;
};

// ---- KPIs ----

/** Raw AI-extracted KPIs (read-only, pre-save) */
export const getExtractedKpis = async (id) => {
  const response = await apiCall(`${BASE_URL}/documents/${id}/extracted-kpis`, {}, {}, 'GET');
  return response?.data || [];
};

/**
 * Bulk-save reviewed KPIs.
 * kpis: [{ kpiId?, kpiTitle, value, unit, periodStartDate, periodEndDate }]
 */
export const saveKpis = async (documentId, kpis) => {
  const response = await apiCall(
    `${BASE_URL}/documents/${documentId}/kpis`,
    {}, { kpis }, 'POST'
  );
  return response?.data;
};

/** Get already-saved (confirmed) KPIs */
export const getSavedKpis = async (id) => {
  const response = await apiCall(`${BASE_URL}/documents/${id}/kpis`, {}, {}, 'GET');
  return response?.data || [];
};